import { LandingPageBannerBlockCombinedProps } from './types';

const usePresenter = (props: LandingPageBannerBlockCombinedProps): LandingPageBannerBlockCombinedProps => {
  return props;
};

export default usePresenter;
